import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-white mt-20">
      <div className="bg-diamond py-2 border-b border-amber-500" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-white p-1.5">
              <img
                src="/assets/45529113931edd83.png"
                alt="Great Wall Machinery"
                className="h-12 w-auto"
              />
            </div>
            <div>
              <div className="font-display font-black uppercase tracking-tight">Great Wall Machinery</div>
              <div className="font-mono text-xs text-slate-400 uppercase tracking-wider">Henan · China</div>
              <div className="font-mono text-xs text-amber-500 uppercase tracking-wider">LATAM · España · Portugal</div>
            </div>
          </div>
          <p className="text-slate-400 max-w-md leading-relaxed text-sm">
            Empresa que gestiona y representa Great Wall Machinery en Latinoamérica, España y Portugal.
          </p>
        </div>

        <div>
          <div className="text-xs font-display font-bold tracking-[0.2em] uppercase text-amber-500 mb-4">Navegación</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-amber-400 transition-colors">Inicio</Link></li>
            <li><Link to="/catalogo" className="hover:text-amber-400 transition-colors">Catálogo</Link></li>
            <li><Link to="/contacto" className="hover:text-amber-400 transition-colors">Contacto</Link></li>
            <li><Link to="/login" className="hover:text-amber-400 transition-colors">Acceso administración</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-display font-bold tracking-[0.2em] uppercase text-amber-500 mb-4">Contacto</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 mt-0.5 text-amber-500 shrink-0" />
              <a href="tel:+56961018000" className="hover:text-amber-400 transition-colors">+569 6101 8000</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-0.5 text-amber-500 shrink-0" />
              <a href="mailto:contacto@gwmlatam.com" className="hover:text-amber-400 transition-colors break-all">
                contacto@gwmlatam.com
              </a>
            </li>
            <li className="flex items-start gap-2 text-slate-400">
              <MapPin className="w-4 h-4 mt-0.5 text-amber-500 shrink-0" />
              <span>Latinoamérica · España · Portugal</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500 font-mono uppercase tracking-wider">
            © {new Date().getFullYear()} Great Wall Machinery LATAM. Todos los derechos reservados.
          </p>
          <p className="text-xs text-slate-500 font-mono uppercase tracking-wider">
            Henan Greatwall Machinery Co., Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
}
